import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Chip.module.scss";
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
export const Chip = ({ tone = "neutral", dot = false, className, children, ...rest }) => {
    return (_jsxs("span", { className: cn(styles.chip, styles[`tone${cap(tone)}`], className), ...rest, children: [dot && (_jsx("span", { className: cn(styles.dot, dot === "pulse" && styles.pulse), "aria-hidden": "true" })), children] }));
};
